export enum BlockingRulesetOperators {
  LessThan = '<',
  LessThanAndEqualTo = '<=',
  Equal = '==',
  NotEqual = '!=',
  GreaterThanAndEqualTo = '>=',
  Greater = '>',
}
